import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import ReportProductCustomerListMain from "../../../features/report/report-product-customer-list/component/report-product-customer-list-main";

const title = "Report Product Customer List";

const ReportProductCustomerListPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <ReportProductCustomerListMain />;
};

export default ReportProductCustomerListPage;
